export default __webpack_public_path__ + "static/media/formLevelWarningsIcon.3190b585.svg";